import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import pittsburgh__asset from "@/assets/restore/locations/pittsburgh.jpg.asset.json";
import philadelphia__asset from "@/assets/restore/locations/philadelphia.jpg.asset.json";

const map = (q: string) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;

const cities: StateCity[] = [
  {
    name: "Philadelphia",
    address: "325-41 Chestnut Street, Suite 800",
    img: philadelphia__asset.url,
    mapUrl: map("325-41 Chestnut Street Suite 800 Philadelphia PA"),
    to: "/locations/pennsylvania/philadelphia/",
  },
  {
    name: "Pittsburgh",
    address: "322 North Shore Drive, Building 1B, Suite 200",
    img: pittsburgh__asset.url,
    mapUrl: map("322 North Shore Drive Pittsburgh PA"),
    to: "/locations/pennsylvania/pittsburgh/",
  },
];

export const Route = createFileRoute("/locations/pennsylvania/")({
  head: () => ({
    meta: [
      { title: "Pennsylvania Hair Transplants | RESTORE® Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair in Pennsylvania. Book a free personal hair loss consultation at our Pittsburgh location and learn about our FUE hair transplant procedure.",
      },
      { property: "og:title", content: "Pennsylvania Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair in Pittsburgh, Pennsylvania and book a free consultation.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/pennsylvania/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/pennsylvania/" }],
  }),
  component: () => <StateLocationsHub stateName="Pennsylvania" cities={cities} />,
});